<template lang="html">

  <section class="accueil">
    <div id="content">
      <banniere-accueil/>
      <panel-facts/>
      <panel-evenement titre="A la une des <b>Evenéments</b>" message="Découvrez les événements du moment" type="EVENEMENTS"/>
      <lien-voir-plus lien="/evenement/EVENEMENTS" message="Voir plus d'événements"/>
      <btn-consulter/>
      <banniere-horizontale-evenement/>
      <panel-evenement titre="A la une au <b>Cinema</b>" message="Découvrez les films du moment" type="CINEMA"/>
      <lien-voir-plus lien="/evenement/CINEMA" message="Voir plus de films"/>
      <btn-consulter/>
      <!--<panel-pub-evenement/>-->
      <pied-creer-billetterie/>
      <panel-video/>
    </div>
  </section>

</template>

<script lang="js">
  import PiedCreerBilletterie from '@/components/PiedCreerBilletterie.vue'
  import PanelVideo from '@/components/PanelVideo.vue'
  import BanniereAccueil from '@/components/BanniereAccueil.vue'
  import PanelFacts from '@/components/PanelFacts.vue'
  import PanelEvenement from '@/components/PanelEvenement'
  import LienVoirPlus from '@/components/LienVoirPlus'
  import BtnConsulter from '@/components/BtnConsulter'
  import BanniereHorizontaleEvenement from '@/components/BanniereHorizontaleEvenement'
  //import PanelPubEvenement from '@/components/PanelPubEvenement'

  export default  {
    name: 'accueil',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    },
    components : {
      PiedCreerBilletterie,
      PanelVideo,
      BanniereAccueil,
      PanelFacts,
      PanelEvenement,
      LienVoirPlus,
      BtnConsulter,
      BanniereHorizontaleEvenement
      //PanelPubEvenement
    }
}
</script>
